<script setup lang="ts">
import { cn } from "@/lib/utils";
import { toneChipStyle, type LayerTone } from "./layerTone";

defineOptions({ inheritAttrs: false });

const props = withDefaults(defineProps<{
  chip: string;
  tone: LayerTone;
  title: string;
  meta?: string;
  dot?: string | null;
  chevron?: boolean;
}>(), {
  meta: undefined,
  dot: null,
  chevron: true,
});

const emit = defineEmits<{ click: [] }>();
const attrs = useAttrs();
</script>

<template>
  <button
    type="button"
    :class="cn(
      'flex w-full items-center gap-2 rounded-md border bg-background px-[7px] py-[5px] text-left hover:bg-accent/40',
      attrs.class,
    )"
    :aria-label="meta ? `${title}, ${meta}` : title"
    @click="emit('click')"
  >
    <span
      class="inline-flex shrink-0 items-center rounded-full border px-1.5 py-0.5 text-[8.5px] font-bold tracking-[0.08em]"
      :style="toneChipStyle(tone)"
    >
      {{ chip }}
    </span>
    <span class="min-w-0 flex-1">
      <span class="block truncate text-[11.5px] font-semibold">{{ title }}</span>
      <span v-if="meta" class="block truncate text-[10px] text-muted-foreground">{{ meta }}</span>
    </span>
    <span v-if="dot" :class="['size-2 shrink-0 rounded-full border', dot]" />
    <Icon
      v-if="chevron"
      mode="svg"
      size="12"
      name="lucide:chevron-right"
      class="shrink-0 text-muted-foreground"
    />
  </button>
</template>
